export const useDiscardConfirm = (message: string) => {
  const confirmDiscard = () => window.confirm(message);
  return { confirmDiscard };
};
